import React from 'react'
import './styles.css'
function Chapter6() {
  return (
    <div className="conta6">
    </div>
  )
}

export default Chapter6